<kendo-svg-icon
  (click)="onStartTour()"
  size="xxxlarge"
  class="tour-button"
  [icon]="icon"
></kendo-svg-icon>
